import { render } from "./PartC.vue?vue&type=template&id=6207a2bf"
import script from "./PartC.vue?vue&type=script&lang=js"
export * from "./PartC.vue?vue&type=script&lang=js"

import "./PartC.vue?vue&type=style&index=0&id=6207a2bf&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__